<template>
  <div class="content">
    <div class="ttile">
      视频
      <span>
        说明：支持添加原生视频或视频链接地址。
      </span>
    </div>

    <div class="content_set">
      <p>内容设置</p>
      <div>
        <div class="select_type">
          <span>视频</span>
          <SpRadio
            v-model="curComponent.uploadType"
            size="small"
            :options="videoTypeOptions"
          />
        </div>

        <div
          v-show="curComponent.uploadType === 'uploadVideo'"
          class="upload_video"
        >
          <UploadVideo v-model="curComponent.videoUrl" />
          <p>
            视频大小不超过200MB，建议时长五分钟以内，支持上传16:9/9:16/3:4尺寸视频，支持的视频文件类型包括：.mp4,
            .mov, .m4v, .flv, .xflv, .mkv, .wmv, .avi, .rmvb, .3gp。
          </p>
        </div>

        <div
          v-show="curComponent.uploadType === 'videoUrl'"
          class="other_content"
        >
          <el-input
            v-model="curComponent.videoUrl"
            placeholder="请输入视频地址"
          ></el-input>

          <div class="video_preview" v-if="!curComponent.videoUrl">
            <img src="../../../assets/images/play-icon.png" alt="" />
          </div>

          <div class="video_preview" v-else>
            <video
              controls
              :poster="
                curComponent.coverType === 'uploadImg'
                  ? curComponent.coverImgUrl
                  : ''
              "
              :src="curComponent.videoUrl"
              type="video/mp4"
            ></video>
          </div>
        </div>

        <div
          v-show="curComponent.uploadType === 'videoLibrary'"
          class="other_content"
        >
          <el-button size="mini" @click="selectVideo"
            >选择文章库视频 +</el-button
          >

          <div class="video_preview" v-if="!curComponent.videoUrl">
            <img src="../../../assets/images/play-icon.png" alt="" />
          </div>
          <div class="video_preview" v-else>
            <video
              controls
              :poster="
                curComponent.coverType === 'uploadImg'
                  ? curComponent.coverImgUrl
                  : ''
              "
              :src="curComponent.videoUrl"
              type="video/mp4"
            ></video>
          </div>
        </div>
      </div>

      <div>
        <div class="select_type">
          <span>封面</span>
          <SpRadio
            v-model="curComponent.coverType"
            size="big"
            :options="coverTypeOptions"
          />
        </div>

        <div v-show="curComponent.coverType === 'default'" class="tip_text">
          建议尺寸：800 * 800px，支持.jpg, .gif, .png, .bmp格式，大小不超过10
          MB。如果不添加封面，系统会默认截取视频的第一个画面作为封面。
        </div>

        <div
          class="upload_content"
          v-show="curComponent.coverType === 'uploadImg'"
        >
          <UploadImg v-model="curComponent.coverImgUrl" />
          <p>建议图宽高比例与视频高比一致</p>
        </div>
      </div>
    </div>

    <div class="set_item">
      <p class="title">样式基础设置</p>
      <SpSwitch
        v-model="curComponent.showSlider"
        label="进度条"
        active-text="显示"
        inactive-text="不显示"
      />
      <SpSwitch
        v-model="curComponent.isAutoPlay"
        tipText="自动播放支持app和小程序，且当用户网络为4g/5g/wifi时生效。开启自动播放后，可设置播放声音"
        label="自动播放"
      />
      <SpSwitch
        v-model="curComponent.isHaveAudio"
        tipText="视频不自动播放声音。需用户手动点击🔈（扬声器按钮）开启声音。"
        label="视频声音"
      />
    </div>

    <div class="set_item">
      <p class="title">视频样式</p>
      <SpRadio
        v-model="curComponent.radius"
        label="视频倒角"
        :options="radiusOptions"
      />
      <SpSlider v-model="curComponent.mx" label="页面边距" />
    </div>

    <videoListSelect
      :SelectedvideoList="videoListSelect.SelectedvideoList"
      :limitNumber="videoListSelect.limitNumber"
      :isShowDialog="videoListSelect.isShowDialog"
      :prescriptionTypeListData="videoListSelect.prescriptionTypeList"
      @selectvideoList="selectvideoList"
      @closeShowDialog="closeShowDialog"
    >
    </videoListSelect>
  </div>
</template>
<script>
import SpRadio from "../../../components/SpRadio";
import SpSwitch from "../../../components/SpSwitch";
import SpSlider from "../../../components/SpSlider";
import UploadImg from "./components/UploadImg";
import UploadVideo from "./components/UploadVideo";
import videoListSelect from "@/myviews/shoppMall/popularscienceManage/rdvideoManage/components/videoListSelect";
import { videoTypeOptions, coverTypeOptions, radiusOptions } from "./options";
export default {
  inject: ["control"],
  components: {
    SpRadio,
    SpSwitch,
    SpSlider,
    UploadImg,
    UploadVideo,
    videoListSelect
  },
  computed: {
    curComponent: {
      get() {
        return this.control.curComponent;
      },
      set(val) {
        this.control.curComponent = val;
      }
    }
  },
  watch: {
    "curComponent.uploadType": {
      handler() {
        this.curComponent.videoUrl = "";
      }
    }
  },
  data() {
    return {
      videoTypeOptions,
      coverTypeOptions,
      radiusOptions,
      videoListSelect: {
        isShowDialog: false,
        type: "",
        id: "",
        limitNumber: 0,
        SelectedvideoList: []
      }
    };
  },
  methods: {
    selectVideo() {
      this.videoListSelect.limitNumber = 1;
      this.videoListSelect.isShowDialog = true;
    },
    closeShowDialog() {
      this.videoListSelect.isShowDialog = false;
    },
    selectvideoList(list) {
      const { videoUrl } = list[0];
      this.videoListSelect.SelectedvideoList = list;
      this.curComponent.videoUrl = videoUrl;
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    span {
      font-size: 10px;
      color: #999999;
      margin-top: 4px;
    }
  }

  .content_set {
    padding: 20px 24px;
    > p {
      padding-bottom: 20px;
      font-weight: 500;
      font-size: 14px;
    }
    > div {
      width: 332px;
      background: #f7f8fa;
      border-radius: 4px;
      padding: 10px 24px 20px 10px;
      > .select_type {
        display: flex;
        align-items: center;
        > span {
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          padding-right: 30px;
          white-space: nowrap;
        }
      }
      > .upload_video {
        padding-left: 54px;
        padding-top: 10px;
        > p {
          font-size: 10px;
          color: #999999;
          line-height: 14px;
          margin-top: 10px;
        }
      }
      > .other_content {
        margin-left: 54px;
        padding-top: 10px;
        > .input_box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 5px;
        }
        > .video_preview {
          margin-top: 10px;
          width: 244px;
          height: 134px;
          background: #ffffff;
          border-radius: 3px;
          border: 1px solid #eeeeee;
          display: flex;
          align-items: center;
          justify-content: center;
          > img {
            width: 26px;
            height: 26px;
          }
          > video {
            width: 100%;
            height: 100%;
          }
        }
      }
      > .tip_text {
        font-size: 10px;
        color: #999999;
        line-height: 14px;
        padding-top: 10px;
        margin-left: 54px;
      }
      > .upload_content {
        padding-left: 54px;
        padding-top: 10px;
        > p {
          font-weight: 400;
          font-size: 10px;
          color: #999999;
          margin-top: 10px;
          line-height: 14px;
        }
      }
    }
  }

  > .set_item {
    padding: 10px 24px 0 24px;
    > .title {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 12px;
    }
    /deep/ .switch-content,
    .sp-radio,
    .slider-content {
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/XVideo/Attr.vue